/**
 * CloudSlides Shopify Theme JavaScript
 * Handles sticky header, mobile drawer, accordions, and interactions
 */
document.addEventListener('DOMContentLoaded', () => {
  // Sticky Header
  const header = document.querySelector('.site-header');
  if (header && header.dataset.sticky === 'true') {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 120) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // Mobile Drawer
  const mobileMenuBtn = document.querySelector('[data-mobile-menu-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const mobileDrawerClose = document.querySelector('[data-mobile-drawer-close]');

  if (mobileMenuBtn && mobileDrawer) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileDrawer.classList.toggle('is-open');
      document.body.classList.toggle('overflow-hidden');
    });
    if (mobileDrawerClose) {
      mobileDrawerClose.addEventListener('click', () => {
        mobileDrawer.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
      });
    }
  }

  // Accordions (FAQ)
  const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
  accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      
      trigger.setAttribute('aria-expanded', !isOpen);
      if (content) {
        content.hidden = isOpen;
      }
    });
  });
});
